export enum SlidePreset {
    FirstSlide = 'FirstSlide',
}
